import { getNamespace } from '../utils/namespace'

export default {
  generateValidCode: {
    path: getNamespace() + '/api/security/captcha/generate',
    method: 'get'
  },
  validateCode: {
    path: getNamespace() + '/api/security/captcha/validate',
    method: 'get'
  },
  login: {
    path: getNamespace() + '/auth/login',
    method: 'post'
  },
  logout: {
    path: getNamespace() + '/auth/logout',
    method: 'post'
  },
  getUserInfo: {
    path: getNamespace() + '/api/security/user/info/get',
    method: 'get'
  },
  getUserAvatar: {
    path: getNamespace() + '/api/user/avatar/get',
    method: 'get',
    comment: '查询用户头像'
  },
  getUserBase64Avatar: {
    path: getNamespace() + '/api/user/avatar/base64/get',
    method: 'get',
    comment: '查询base64的用户头像'
  },
  getTenant: {
    path: getNamespace() + '/auth/tenant/get',
    method: 'get',
    comment: '查询租户'
  },
  getCurrentCourtTrial: {
    path: getNamespace() + '/api/juror/day/trial/info/list',
    method: 'post',
    comment: '查询当前庭审信息'
  },
  doSign: {
    path: getNamespace() + '/api/juror/juryStatus/sign',
    method: 'post',
    comment: '陪审员签到'
  },
  getJurorInfo: {
    path: getNamespace() + '/api/juror/info/get',
    method: 'get',
    comment: '获取陪审员信息'
  },
  // V1.2.0迭代接口
  // 获取陪审员和用户信息
  JurorInfoGet: {
    path: getNamespace() + '/api/juror/info/get',
    method: 'post'
  },
  // 获取验证码
  getCaptcha: {
    path: getNamespace() + '/auth/captcha/generate',
    method: 'get',
    responseType: 'text'
  },
  // 修改密码
  modifyPwd: {
    path: getNamespace() + '/api/juror/pwd/update',
    method: 'post'
  },
  // 修改手机号码
  modifyPhoneNum: {
    path: getNamespace() + '/api/juror/phone/update',
    method: 'post'
  },
  // 修改用户头像
  modifyUserAvatar: {
    path: getNamespace() + '/api/juror/avatar/update',
    method: 'POST'
  },
  // 根据手机号码获取验证码
  getPhoneCaptcha: {
    path: getNamespace() + '/api/juror/captcha/generate',
    method: 'post'
  },
  // 上传个人电子签名
  uploadESignature: {
    path: getNamespace() + '/api/juror/electronSign/upload',
    method: 'post',
    contentType: 'multipart/form-data;charset=UTF-8'
  },
  // 获取个人电子签名
  getESign: {
    path: getNamespace() + '/api/juror/electronSign/get',
    method: 'get'
  },
  // 获取当前用户的角色
  getRoles: {
    path: getNamespace() + '/api/user/code/list',
    method: 'get'
  },
  getJudgeInfo: {
    path: getNamespace() + '/api/user/get',
    method: 'get'
  },
  // 获取签到范围半径
  getSignRange: {
    path: getNamespace() + '/api/open/signRange/get',
    method: 'get',
    contentType: 'text'
  }
}



// WEBPACK FOOTER //
// ./src/apis/user.js